import { render, staticRenderFns } from "./DsfExamPage.vue?vue&type=template&id=a90d7154&"
import script from "./DsfExamPage.vue?vue&type=script&lang=js&"
export * from "./DsfExamPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfExamPage.vue"
export default component.exports